<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/a91GOj/tc-custom/9781453223659.jpg?1708749930351" alt="This image is the cover for the book In the Balance, The Miss Silver Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">In the Balance, The Miss Silver Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>The “marvelous” British governess-turned-sleuth helps a new bride who fears her husband intends to murder her (<i>Daily Mail</i>).</b><br/><br/> Former schoolteacher Miss Maud Silver is on her way back to London when, with a violent shudder of the train, a young woman is thrust into her compartment. She’s beautiful, well dressed, newly married, and wealthy—a lethal combination.<br/><br/> In a state of shock, Lisle Jerningham explains that she fled her home in a hurry after overhearing a sinister conversation. Her new husband’s first wife died in an apparent accident, and the resultant infusion of cash saved his family home. Now, he’s broke again—and attempting to engineer a second convenient mishap. Miss Silver is unsure whether the drama is real or a figment of Lisle’s imagination—but if this frightened young lady is a target for murder, the killer will have to deal with the governess-turned-sleuth first.<br/><br/>  Starring a mature sleuth who “has her place in detective fiction as surely as Lord Peter Wimsey or Hercule Poirot”, <i>In the Balance </i>is a classic British mystery (<i>Manchester Evening News</i>).
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Patricia  Wentworth
      </h2>
      
      <p class="authorDescription body article">Patricia Wentworth (1878&ndash;1961) was one of the masters of classic English mystery writing. Born in India as Dora Amy Elles, she began writing after the death of her first husband, publishing her first novel in 1910. In the 1920s, she introduced the character who would make her famous: Miss Maud Silver, the former governess whose stout figure, fondness for Tennyson, and passion for knitting served to disguise a keen intellect. Along with Agatha Christie&rsquo;s Miss Marple, Miss Silver is the definitive embodiment of the English style of cozy mysteries.<BR></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6f034121